import Vue from 'vue';

const success = ({ data }, resolve) => {
  resolve(data);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`orders/get_next_prev_id/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/getNextPreviousId.js